import React from "react";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import ButtonVariant from "app/components/Button/ButtonVariant";

import styles from "./styles.module.scss";

type CheckoutErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  title?: string;
};

export default function CheckoutErrorModal(props: CheckoutErrorModalProps) {
  const { isOpen, onClose, message, title } = props;
  const { t } = useTranslation();

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose} classNames={styles.modal}>
      <div className={styles.modal_content}>
        <div className={styles.title_and_content}>
          <div className={styles.title}>
            <i className={`ico ico-x ${styles.error_icon}`} />
            <h2>{title || t("Checkout Error")}</h2>
          </div>
          <p className={styles.message}>{message}</p>
          <div className={styles.actions}>
            <ButtonVariant
              buttonType="primary"
              title={t("OK")}
              onClickFunc={onClose}
            />
          </div>
        </div>
      </div>
    </ModalLayout>
  );
}
